import { useNavigate, useParams } from "react-router-dom";
import Order from "../../pages/orders/pg-orders";
import Footer from "../../components/footer-tab/fixedfooter";
import ViewInvoice from "../../pages/orders/components/view-invoice/view-invoice";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import { ToastContainer } from "react-toastify";

export function RTOrder(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Order navigate={navigate} params={params} />
      <Footer navigate={navigate} />
    </>
  );
}

export function RTViewInvoice(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <ViewInvoice navigate={navigate} params={params} />
      <Footer navigate={navigate} />
    </>
  );
}
